// For type checking

function isAString(value) {
	return (typeof value === "string" || value instanceof String)
}

function isANumber(value) {
	return (Number.isNaN(Number(value)) === false)
}

// For parsing the possible min and max values in a DiViNa JSON's viewportRatio property
function parseMinOrMaxRatio(minOrMax) {
	if (minOrMax && minOrMax.split(":").length === 2) {
		const parts = minOrMax.split(":")
		const constraintWidth = parts[0]
		const constraintHeight = parts[1]
		if (isANumber(constraintWidth) === true && isANumber(constraintHeight) === true
			&& constraintWidth !== 0 && constraintHeight !== 0) {
			return constraintWidth / constraintHeight
		}
	}
	return null
}

// For parsing a mediaFragment string
function parseMediaFragmentString(mediaFragmentString) {
	const mediaFragmentStringParts = mediaFragmentString.split("=")
	if (mediaFragmentStringParts.length !== 2) {
		return null
	}

	let fragmentInfo = mediaFragmentStringParts[1]
	fragmentInfo = fragmentInfo.split(":")
	if (fragmentInfo.length !== 2) {
		return null
	}

	const [unit, xywh] = fragmentInfo
	if (unit !== "percent" && unit !== "pixel") {
		return null
	}
	const xywhArray = xywh.split(",")
	if (xywhArray.length !== 4) {
		return null
	}

	let [x, y, w, h] = xywhArray
	x = Number(x)
	y = Number(y)
	w = Number(w)
	h = Number(h)
	if (!isANumber(x) || !isANumber(y) || !isANumber(w) || !isANumber(h)) {
		return null
	}

	return {
		unit, x, y, w, h,
	}
}

// For parsing and computing a snap point coordinate

function parseCoordinate(value, dimensionLength) {
	if (!value) {
		return 0
	}
	if (isAString(value) === false) {
		return null
	}
	let valueParts = value.split("%")
	let relValue = valueParts[0]
	if (valueParts.length === 2 && Number.isNaN(Number(relValue)) === false) {
		return (Number(relValue) * dimensionLength) / 100
	}
	valueParts = relValue.split("px")
	relValue = Number(valueParts[0])
	if (valueParts.length === 2 && Number.isNaN(Number(relValue)) === false) {
		return Number(relValue)
	}
	return null
}

// For handling resources

function getFileExtension(path) {
	if (!path) {
		return null
	}
	const pathParts = path.split(".")
	const extension = pathParts[pathParts.length - 1]
	return extension
}

function isType(path, type, acceptableGeneralType, acceptableExtensions) {
	if (type) {
		const generalType = type.split("/")[0]
		if (generalType === acceptableGeneralType) {
			return true
		}
		return false
	}
	const extension = getFileExtension(path)
	if (extension && acceptableExtensions) {
		acceptableExtensions.forEach((acceptableExtension) => {
			if (extension === acceptableExtension) {
				return true
			}
		})
	}
	return false
}

function isImage(path, type) {
	return isType(path, type, "image", ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "webp"])
}


function isVideo(path, type) {
	return isType(path, type, "video", ["mp4", "mov", "m4v", "webm"])
}

function getPathFromHref(folderPath, href) {
	const path = (folderPath) ? `${folderPath}/${href}` : href
	return path
}

function getPathAndMediaFragmentString(folderPath, href) {
	const hrefParts = href.split("#")
	const nonMediaFragmentPart = hrefParts[0]
	const path = getPathFromHref(folderPath, nonMediaFragmentPart)
	const mediaFragmentString = (hrefParts.length > 1) ? hrefParts[1] : null
	return { path, mediaFragmentString }
}

function getResourceData(folderPath, href, type, fallbackHref = null) {
	if (!href) {
		return {}
	}

	const { path, mediaFragmentString } = getPathAndMediaFragmentString(folderPath, href)

	let resourceType = null
	if (isImage(href, type) === true) {
		resourceType = "image"
	} else if (isVideo(href, type) === true) {
		resourceType = "video"
	}
	let resourceData = {
		href, path, mediaFragmentString, resourceType,
	}

	if (fallbackHref) {
		const fallbackInfo = getPathAndMediaFragmentString(folderPath, fallbackHref)
		resourceData = {
			...resourceData,
			fallbackHref,
			fallbackPath: fallbackInfo.path,
			fallbackMediaFragmentString: fallbackInfo.mediaFragmentString,
		}
	}

	return resourceData
}

// For manipulating snap points
function getDistance(point1, point2) {
	return Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2)
}

export {
	isANumber,
	parseMinOrMaxRatio,
	parseMediaFragmentString,
	parseCoordinate,
	getPathFromHref,
	getResourceData,
	getDistance,
}